module.exports = __webpack_public_path__ + "f8f821a66b20e5801e35df5ec4565b30.wasm";